"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebviewRatio = exports.BroadcastType = void 0;
var BroadcastType;
(function (BroadcastType) {
    BroadcastType[BroadcastType["Text"] = 'text'] = "Text";
    BroadcastType[BroadcastType["Poll"] = 'poll'] = "Poll";
    BroadcastType[BroadcastType["Carousel"] = 'carousel'] = "Carousel";
    BroadcastType[BroadcastType["Media"] = 'media'] = "Media";
})(BroadcastType = exports.BroadcastType || (exports.BroadcastType = {}));
var WebviewRatio;
(function (WebviewRatio) {
    WebviewRatio[WebviewRatio["COMPACT"] = 'compact'] = "COMPACT";
    WebviewRatio[WebviewRatio["TALL"] = 'tall'] = "TALL";
    WebviewRatio[WebviewRatio["FULL"] = 'full'] = "FULL";
})(WebviewRatio = exports.WebviewRatio || (exports.WebviewRatio = {}));
